// removed by extract-text-webpack-plugin
module.exports = {"xsmall":"only screen and (min-width: 375px)","small":"only screen and (min-width: 481px)","medium":"only screen and (min-width: 768px)","large":"only screen and (min-width: 993px)","xlarge":"only screen and (min-width: 1201px)","retina":"(-webkit-min-device-pixel-ratio: 2)","weWill":"weWill-36EXL","content":"content-1daxR","screen":"screen-3elah"};


//////////////////
// WEBPACK FOOTER
// ./src/components/app-page/we-will/_weWill.css
// module id = 1179
// module chunks = 1